// Shared stage taxonomy and helpers used across queries, UI, and server functions.

export type StageKey =
  | "recruiter"
  | "hiring_manager"
  | "portfolio"
  | "panel"
  | "leadership"
  | "offer";

export type StageOutcome =
  | "pending"
  | "passed"
  | "rejected"
  | "ghosted"
  | "withdrawn";

export const STAGE_KEYS: StageKey[] = [
  "recruiter",
  "hiring_manager",
  "portfolio",
  "panel",
  "leadership",
  "offer",
];

export const STAGE_LABELS: Record<StageKey, string> = {
  recruiter: "Recruiter",
  hiring_manager: "Hiring Manager",
  portfolio: "Portfolio",
  panel: "Panel",
  leadership: "Leadership",
  offer: "Offer",
};

export const STAGE_DESCRIPTIONS: Record<StageKey, string> = {
  recruiter: "Initial screen — fit, comp, motivation, logistics",
  hiring_manager: "Role depth, team fit, behavioural STAR",
  portfolio: "Case walkthrough, technical / portfolio review",
  panel: "Cross-functional collaboration, influence, disagreement",
  leadership: "Strategic thinking, business impact, vision",
  offer: "Negotiation, references, reverse-interview questions",
};

export function stageDisplay(stage: { stage_key: string; custom_label?: string | null }) {
  if (stage.custom_label && stage.custom_label.trim()) return stage.custom_label.trim();
  return STAGE_LABELS[stage.stage_key as StageKey] ?? stage.stage_key;
}

export function isStageKey(value: string): value is StageKey {
  return (STAGE_KEYS as string[]).includes(value);
}

export function daysBetween(fromIso: string, toIso?: string | null): number {
  const from = new Date(fromIso).getTime();
  const to = toIso ? new Date(toIso).getTime() : Date.now();
  return Math.max(0, Math.floor((to - from) / (1000 * 60 * 60 * 24)));
}
